module.exports = __webpack_public_path__ + "img/pr-14.4c87132b.png";